import type { ScanMode } from '@/lib/api';

/** The scan modes a user can choose for a manual scan (END-177). */
export const SCAN_MODE_OPTIONS: { mode: ScanMode; label: string; description: string }[] = [
  {
    mode: 'incremental',
    label: 'Incremental',
    description: 'Analyses only the files changed since the last scan. Fast; skips analysis when nothing changed.',
  },
  {
    mode: 'full',
    label: 'Full repository',
    description: 'Analyses every eligible file at the latest commit, even unchanged ones. Can take longer.',
  },
];
